import RoutesUtils from './../../js/RoutesUtils.js';
import { barreraBloqueoVacaciones } from './barreraBloqueoVacaciones.js';
// #425 · la lista de roles vive en `permisos.js` y la comparten estas dos rutas y quien enlace con
// el calendario (hoy, el aviso de planificaciones abiertas del pedido). Escrita en dos sitios
// contestaba distinto y el enlace acababa llevando a un 403.
import { ROLES_CALENDARIO } from './permisos.js';

// #49 · las DOS rutas del calendario entran por la misma barrera, que resuelve el acceso y el
// interruptor `rh.vacaciones.bloqueo-generico` antes de montar la pantalla. No se usa aquí
// `RoutesUtils.checkPermission`: la barrera hace ese mismo control de acceso y además trae el
// interruptor ya decidido, que es lo que permite que `calendario.vue` lo reciba como `prop` y
// ninguna escritura tenga que preguntarse si ya se sabe. El porqué, en `barreraBloqueoVacaciones.js`.
//
// #174 · lo que cambió es solo qué se pinta cuando algo no se sabe, no cómo se engancha: el fallo
// del interruptor monta el calendario con el valor restrictivo y un aviso, y el fallo del acceso
// sigue enseñando `calendario-no-disponible`. Las rutas no se enteran, y por eso siguen igual.
//
// #59 · la lista de roles ya no se escribe aquí: la tiene `permisos.js`, que es a quien pregunta
// también la bandeja del aprobador antes de ofrecer «Ver calendario». Escrita en dos sitios, el
// enlace se enseñaba a quien la barrera no deja entrar.

const routes = [

    {
        path: '/calendario/:username/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: barreraBloqueoVacaciones(ROLES_CALENDARIO),
        keepAlive: false
    },
    {
        path: '/calendario/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: barreraBloqueoVacaciones(ROLES_CALENDARIO),
        keepAlive: false
    }

];
export default routes;
